import { DEFAULT_LIMIT, DEFAULT_PAGE } from "@packages/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	page: z.number().catch(DEFAULT_PAGE),
	limit: z.number().catch(DEFAULT_LIMIT),
	search: z.string().catch(""),
	// Preserve the org-level farm scope param across the redirect.
	farm: z.string().optional(),
});

// Establishment management moved into Settings → Farms. Redirect the legacy
// URL (and any existing bookmarks/links) to its new home, preserving search.
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/establishments/",
)({
	validateSearch: searchSchema,
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: "/app/org/$orgId/settings/establishments",
			params: { orgId: params.orgId },
			search,
			replace: true,
		});
	},
});
